export const LOGIN_CONST = {
    FORM: {
        LOGO_ALT: 'Логотип Victory Center',
        TITLE: 'Вхід до системи',
        EMAIL_FIELD_LABEL: 'Електронна пошта',
        PASSWORD_FIELD_LABEL: 'Пароль',
        HIDDEN_PASSWORD_ALT: 'Пароль приховано',
        SHOWED_PASSWORD_ALT: 'Пароль показано',
        SUBMIT_BUTTON: 'Увійти',
    },

    ERROR_MODAL: {
        TITLE: 'Помилка входу',
        CONTENT: 'Неправильний логін або пароль',
        BUTTON: 'OK',
    },
};
